import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import HeaderBottom from "../../components/HomePage/HeaderBottom";


const AllPosts = () => {
    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const postsPerPage = 10;

    useEffect(() => {
        fetch("https://aprilone-178ea8362c0b.herokuapp.com/posts")
            .then((res) => res.json())
            .then((data) => {
                console.log("Fetched Blog Posts:", data);
                setPosts(data.reverse());
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching blog posts:", error);
                setLoading(false);
            });
    }, []);

    const handleDelete = (titleSlug) => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/blog/${titleSlug}`, {
            method: "DELETE",
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Post deleted:", data);
                setPosts(posts.filter((post) => post.titleSlug !== titleSlug)); // Remove the post from the state
            })
            .catch((error) => {
                console.error("Error deleting post:", error);
            });
    };


    const indexOfFirstPost = (currentPage - 1) * postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfFirstPost + postsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil(posts.length / postsPerPage);

    return (
        <>
            <HeaderBottom />
            <div className="min-vh-100 d-flex flex-column">
                <div className="container mt-5 flex-grow-1">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h1 className="text-3xl font-bold">Blog Post List</h1>
                        <Link
                            className="button-professional"
                            to="/add-post"
                        >
                            Add Post
                        </Link>
                    </div>

                    <div className="table-responsive">
                        <table className="table  ">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th scope="col" className="text-center">Sl. No.</th>
                                    <th scope="col">Image</th>
                                    <th scope="col">Post Title</th>
                                    <th scope="col">Category</th>
                                    {/* <th scope="col">Author</th> */}
                                    <th scope="col">Date</th>
                                    <th scope="col" className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" className="text-center">Loading...</td>
                                    </tr>
                                ) : currentPosts.length > 0 ? (
                                    currentPosts.map((post, index) => (
                                        <tr key={post._id}>
                                            <td className="text-center">{(currentPage - 1) * postsPerPage + index + 1}</td>
                                            <td>
                                                <img
                                                    src={post.featuredImage}
                                                    className="rounded"
                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                    alt="Featured"
                                                />
                                            </td>
                                            <td><b>{post.postTitle}</b></td>
                                            <td>{post.postCategoryName}</td>
                                            {/* <td>{post.authorName}</td> */}
                                            <td>{new Date(post.postDate).toLocaleDateString()}</td>
                                            <td className="text-center">
                                                <Link
                                                    to={`/edit-post/${post.titleSlug}`}
                                                    className="btn btn-lg btn-outline-primary"
                                                >
                                                    <i className="fas fa-edit"></i> Edit
                                                </Link>
                                                <Link to={`/blog/${post.titleSlug}`} className="btn btn-lg btn-outline-primary ms-2">
                                                    <i className="fas fa-eye"></i> Preview
                                                </Link>
                                                <button
                                                    onClick={() => handleDelete(post.titleSlug)}
                                                    className="btn btn-lg btn-outline-danger ms-2"
                                                >
                                                    <i className="fas fa-trash"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted">No blog posts found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <nav aria-label="Page navigation example" className="mt-4">
                        <ul className="pagination justify-content-center">
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNumber) => (
                                <li
                                    key={pageNumber}
                                    className={`page-item ${currentPage === pageNumber ? "active" : ""}`}
                                    onClick={() => handlePageChange(pageNumber)}
                                >
                                    <button className="page-link">{pageNumber}</button>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    
                </div>
            </div>

        </>
    );
};

export default AllPosts;